import * as validators from "@vuelidate/validators";
import { createI18nMessage, helpers } from "@vuelidate/validators";
import { t } from "@/i18n";
import moment from "moment";

const wrapWith = (path = "") =>
    createI18nMessage({
        t,
        messagePath: () => path,
    });

export const required = wrapWith("shared.invalid.required")(validators.required);
export const email = wrapWith("shared.invalid.email")(validators.email);
export const url = wrapWith("shared.invalid.url")(validators.url);
export const emailList = wrapWith("shared.invalid.email_on_list")((value, siblings, vm) => {
    const emailList = value.split(",").map((email) => email.trim());
    return emailList.every((text) => email.$validator(text, siblings, vm));
});
export const minLength = wrapWith("shared.invalid.min")(validators.minLength, {
    withArguments: true,
});
export const maxLength = wrapWith("shared.invalid.max")(validators.maxLength, {
    withArguments: true,
});
export const minValue = wrapWith("shared.invalid.min_value")(validators.minValue, {
    withArguments: true,
});
export const maxValue = wrapWith("shared.invalid.max_value")(validators.maxValue, {
    withArguments: true,
});

// using minValue / maxValue (from @vuelidate docs) is not enough for our dates (kept as ISO strings)
export const minDateValue = wrapWith("shared.invalid.min_date")(
    (momentParam) => (value) => {
        return (
            !helpers.req(value) ||
            moment(value).startOf("day").isSame(momentParam.startOf("day")) ||
            moment(value).isAfter(momentParam)
        );
    },
    {
        withArguments: true,
    }
);

export const mustBeChecked = wrapWith("shared.invalid.checked")(validators.sameAs(true));
